import { useEffect } from 'react';
import * as signalR from '@microsoft/signalr';
import { dispatch } from '../redux/store';
import { appendNotification } from '../redux/slices/user';

export default function useNotificationHub() {
  useEffect(() => {
    const token = window.localStorage.getItem('accessToken');
    if (!token) return;

    const baseUrl = import.meta.env.VITE_BASE_URL?.replace(/\/$/, '');

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseUrl}/hubs/notifications`, {
        accessTokenFactory: () => window.localStorage.getItem('accessToken') ?? ''
      })
      .withAutomaticReconnect()
      .build();

    connection.on('ReceiveNotification', (notification) => {
      dispatch(appendNotification(notification));
    });

    connection.start().catch(() => {
      // Connection failed — notifications will still be available on next page load
    });

    return () => {
      connection.stop();
    };
  }, []);
}
